import requests from "./httpService";

const AppSettingServices = {

    getAppSettingDetail : async () =>{
        return requests.get(`/appsetting`);
    },
    
    updateAppSettingDetail : async (id,body) =>{
 
        return requests.patch(`/appsetting/${id}`,body);
    },

}

export default AppSettingServices;